<template>
<div>

    <!-- Utilerias -->
    <v-menu v-if="es_cliente_agencia &&  valida_permiso('EmanifiestoAA.catalogos.usuarios.crear')" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Utilerias':''" v-tippy>
                <v-icon>dashboard</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Utilerías</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.catalogos.usuarios.crear')" to="/catalogos/usuarios" @click.shift="openNew('/catalogos/usuarios');">

                <v-icon>mdi-circle-small</v-icon>Usuarios

            </app-bar-item>

        </v-list>
    </v-menu>

    <!-- Vucem-Pedimento -->
    <v-menu v-if="es_cliente_agencia && menu_vucem" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Vucem-Pedimento':''" v-on="on" v-tippy>
                <v-icon>swap_vert</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Vucem-Pedimento</span>
            </v-btn>
        </template>

        <v-list :tile="false" nav>

            <v-menu v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.soia')" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuSoia">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Consulta Rápida SOIA
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/vucem-pedimento/qr">
                        <v-icon>mdi-circle-small</v-icon>Consulta Rapida
                    </app-bar-item>
                    <app-bar-item @click.native="linkConsultaRapida">
                        <v-icon>mdi-circle-small</v-icon>Detalle de Cruce o Módulo del Despacho
                    </app-bar-item>

                </v-list>
            </v-menu>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.linea.captura')" class="font-weight-thin" to="/vucem/lineas" @click.shift="openNew('/vucem/lineas');">
                <v-icon>mdi-circle-small</v-icon>Líneas de Captura
            </app-bar-item>
            <v-divider />

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.pedimento')" to="/reportes/consultar_pedimentos_detalle" @click.shift="openNew('/reportes/consultar_pedimentos_ws');">

                <v-icon>mdi-circle-small</v-icon>Pedimentos

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.cove')" to="/reportes/consultar_coves_ws" @click.shift="openNew('/reportes/consultar_coves_ws');">

                <v-icon>mdi-circle-small</v-icon>COVE

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.edocument')" to="/reportes/consultar_edocuments_ws" @click.shift="openNew('/reportes/consultar_edocuments_ws');">

                <v-icon>mdi-circle-small</v-icon>E-Document

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.acuses')" to="/reportes/consultar_acuses_ws" @click.shift="openNew('/reportes/consultar_acuses_ws');">

                <v-icon>mdi-circle-small</v-icon>Acuses

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.Pedimento.consulta.estado')" to="/reportes/consultar_estados_ws" @click.shift="openNew('/reportes/consultar_estados_ws');">

                <v-icon>mdi-circle-small</v-icon>Estado de Pedimento

            </app-bar-item>

            
        </v-list>
    </v-menu>

    <!-- eManifest -->
    <v-menu v-if="menu_emanifest && es_cliente_agencia" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn :icon="fullWidth <= 1024" :title="fullWidth < 1024?'eManifiesto':''" v-on="on" v-tippy text>
                <v-icon>mdi-clipboard-list-outline</v-icon>
                <span class="caption">eManifiesto</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.manifestacion')" to="/manifestacion/transmitir" @click.shift="openNew('/manifestacion/transmitir');">
                <v-icon>mdi-circle-small</v-icon>Manifestación de Valor
            </app-bar-item>

            <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.carta.porte.consultar') " to="/carta_porte/administrar/cartas" @click.shift="openNew('/carta_porte/administrar/cartas');">
                <v-icon>mdi-circle-small</v-icon>Complemento Carta Porte
            </app-bar-item>

            <app-bar-item v-if="valida_permiso_t('EmanifiestoAA.cfdi.consultar') " to="/carta_porte/administrar/comercio" @click.shift="openNew('/carta_porte/administrar/comercio');">
                <v-icon>mdi-circle-small</v-icon>Complemento Comercio Exterior
            </app-bar-item>

        </v-list>
    </v-menu>
    <!-- Edrive -->
    <v-menu v-if="es_cliente_agencia &&  menu_edrive " bottom offset-y origin="center center" nav transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'eDrive':''" v-tippy>
                <v-icon>account_tree</v-icon>
                <span class="caption" v-show="fullWidth > 1024">E-Drive</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar')" to="/edrive/explorer" @click.shift="openNew('/edrive/explorer');">
                <v-icon>mdi-circle-small</v-icon>Consultar Expediente Pedimentos
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.descargar')" to="/expediente_pedimento" @click.shift="openNew('/expediente_pedimento');">
                <v-icon>mdi-circle-small</v-icon>Descargar Expediente Pedimentos
            </app-bar-item>
            <v-divider />
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar')" to="/edrivet" @click.shift="openNew('/edrive/edrivet');">
                <v-icon>mdi-circle-small</v-icon>Consultar Expediente Archivos M
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.descargar')" to="/ce_expedientem" @click.shift="openNew('/ce_expedientem');">
                <v-icon>mdi-circle-small</v-icon>Descargar Expediente  Archivos M
            </app-bar-item>
            <v-divider v-if="is_cliente" />
                <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar')" to="/mv_cargazip" @click.shift="openNew('/mv_cargazip');">
                    <v-icon>mdi-circle-small</v-icon>Carga de .Zip archivos M
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar') || valida_permiso('VUCEM.Transmision.ver.edocument')" to="/mv_bitacora" @click.shift="openNew('/mv_bitacora');">
                    <v-icon>mdi-circle-small</v-icon>Bitácora de Archivos M
                </app-bar-item>
                <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar')" to="/manifestacion/expediente" @click.shift="openNew('/manifestacion/expediente');">
                    <v-icon>mdi-circle-small</v-icon>Expediente Manifestación
                </app-bar-item>

                <app-bar-item v-if="valida_permiso('EmanifiestoAA.edrive.consultar')" to="/manifestacion/transmitir" @click.shift="openNew('/manifestacion/transmitir');">
                    <v-icon>mdi-circle-small</v-icon>Manifestación de Valor
                </app-bar-item>
        </v-list>
    </v-menu>



    <!-- Reportes -->
    <v-menu v-if="es_cliente_agencia && view_menu_reportes" bottom offset-y origin="center center" nav transition="scale-transition" >
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'Reportes':''" v-tippy>
                <v-icon>file_copy</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Reportes</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <v-menu v-if="(valida_permiso('EmanifiestoAA.reportes.directos.ws')|| valida_permiso('EmanifiestoAA.reportes.directos.ds') || valida_permiso('EmanifiestoAA.reportes.directom')) " open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuCuentasAduaneras">
                        <app-bar-item @click.native="hideMenuReportes">
                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Reportes Directos</span>
                            <v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('EmanifiestoAA.reportes.directos.ws')" to="/vucem/directo_ws" @click.shift="openNew('/vucem/directo_ws');">

                    <v-icon>mdi-circle-small</v-icon>Directos WS

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('EmanifiestoAA.reportes.directos.ds')" to="/datastage/directo_ds" @click.shift="openNew('/datastage/directo_ds');">

                    <v-icon>mdi-circle-small</v-icon>Directos DS

                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('EmanifiestoAA.reportes.directom')" to="/manifestacion/directo_archivom" @click.shift="openNew('/manifestacion/directo_archivom');">
                            <v-icon>mdi-circle-small</v-icon>Archivo M
                        </app-bar-item>
                </v-list>
            </v-menu>
           
            <app-bar-item v-if="valida_permiso('EmanifiestoAA.predeterminados.ds') && view_trafico==0 && view_costing==0" to="/predeterminados" @click.shift="openNew('');">
                <v-icon>mdi-circle-small</v-icon>Predeterminados DS
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.predeterminados.ws') && view_trafico==0 && view_costing==0" to="/predeterminadosws" @click.shift="openNew('');">
                <v-icon>mdi-circle-small</v-icon>Predeterminados WS
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.rectificaciones') && view_trafico==0 && view_costing==0" to="/rectificaciones" @click.shift="openNew('');">
                <v-icon>mdi-circle-small</v-icon>Rectificaciones
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('EmanifiestoAA.operaciones') && view_trafico==0 && view_costing==0" to="/vucem/operaciones_virtuales" @click.shift="openNew('');">
                <v-icon>mdi-circle-small</v-icon>Operaciones Virtuales
            </app-bar-item>

            <v-menu v-if="(valida_permiso('EmanifiestoAA.permisosprevios') || valida_permiso('DATA.STAGE.permisos.previos.registros')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Permisos Previos</span>
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item  @click.native="hideMenuReportes" to="/permisos_previos/reporteds">
                        <v-icon>mdi-circle-small</v-icon>Registros DS - Permisos
                    </app-bar-item>

                    <app-bar-item  @click.native="hideMenuReportes" to="/permisos_previos/nuevo_permiso">
                        <v-icon>mdi-circle-small</v-icon>Consulta Permisos y Movimientos
                    </app-bar-item>
                </v-list>
            </v-menu>

            <v-menu v-if="(valida_permiso('EmanifiestoAA.cuentasaduaneras') || valida_permiso('DATA.STAGE.cuentas.aduaneras')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" id="menuCuentasAduaneras">
                        <app-bar-item @click.native="hideMenuReportes">
                            <v-icon>mdi-circle-small</v-icon><span style="text-transform: capitalize!important;">Cuentas Aduaneras de Garantía</span>
                            <v-icon>mdi-menu-right</v-icon>

                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/reportes_cuentas_aduaneras/cuentasWS">
                        <v-icon>mdi-circle-small</v-icon>Cuentas Aduaneras WS
                    </app-bar-item>
                    <app-bar-item  @click.native="hideMenuReportes" to="/reportes_cuentas_aduaneras/cuentasDS">
                        <v-icon>mdi-circle-small</v-icon>Cuentas Aduaneras DS
                    </app-bar-item>
                </v-list>
            </v-menu>
           

            <v-menu v-if="(valida_permiso('EmanifiestoAA.analiticos') || valida_permiso('DATA.STAGE.analiticos')) && view_trafico==0 && view_costing==0" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuPermisosPrevios">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-check-decagram</v-icon>&nbsp; Analíticos Gráficos
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item  @click.native="hideMenuReportes" to="/graficas/contribuciones">
                        <v-icon>mdi-circle-small</v-icon>Contribuciones
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuReportes" to="/graficas/pedimentos_patentes_ds">
                        <v-icon>mdi-circle-small</v-icon>Aduana - Patente DS
                    </app-bar-item>
                    <app-bar-item  @click.native="hideMenuReportes" to="/graficas/pedimentos_patentes">
                        <v-icon>mdi-circle-small</v-icon>Aduana - Patente WS
                    </app-bar-item>
                    <app-bar-item  @click.native="hideMenuReportes" to="/graficas/pedimentos_transportes">
                        <v-icon>mdi-circle-small</v-icon>Medios de Transporte WS
                    </app-bar-item>
                </v-list>
            </v-menu>

        </v-list>
    </v-menu>

    <!-- Manual de Usuario -->
    <v-menu v-if="es_cliente_agencia" bottom offset-y origin="center center" nav transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024?'eDrive':''" v-tippy>
                <v-icon>book</v-icon>
                <span class="caption" v-show="fullWidth > 1024">Manual de Usuario</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="!Admin" to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                <v-icon>mdi-circle-small</v-icon>Manual eTips
            </app-bar-item>

            <app-bar-item v-if="!Admin" to="/videotutorial" @click.shift="openNew('/videotutorial');">

                <v-icon>mdi-circle-small</v-icon>Video Tutoriales

            </app-bar-item>

            <app-bar-item @click.native="downloadFile('COVE_DiccionarioDeDatos.pdf');">

                <v-icon>mdi-circle-small</v-icon>Diccionario de COVE

            </app-bar-item>
            <app-bar-item @click.native="downloadFile('ManualConsultaDiccionarioPedimento.pdf');">

                <v-icon>mdi-circle-small</v-icon>Diccionario Pedimento WS

            </app-bar-item>
            <app-bar-item @click.native="downloadFile('ManualConsultaDataStage.pdf');">

                <v-icon>mdi-circle-small</v-icon>Diccionario Data Stage

            </app-bar-item>
            <app-bar-item disabled>

                <v-icon>mdi-circle-small</v-icon>Diccionario Carta Porte

            </app-bar-item>
            <app-bar-item disabled>

                <v-icon>mdi-circle-small</v-icon>Diccionario Complemento CE

            </app-bar-item>

        </v-list>
    </v-menu>

</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";

export default {
    name: "menuEmanifiestoAA",
    components: {

        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100
            && this.$local_storage.get("Modulo18") != 100;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 && 
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100 || this.$local_storage.get("EmanifiestoCP.bitacora") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista") == 1;
        },
        es_cliente_agencia() {
            return this.$local_storage.get("id_cliente") > 0 &&  
                this.$local_storage.get("DATA.STAGE.bitacora") != 100 &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                this.$local_storage.get("EmanifiestoMV.bitacora") != 100 && 
                this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") == 100;   
        },
        es_analytics() {
            return this.view_costing == 0 && this.view_emanifiesto == 0 && this.view_carta_porte == 0 && this.view_trafico == 0 && this.$local_storage.get("id_cliente") > 0;
        },

        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo");;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos");
        },
        soloCartaPorte() {
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
  
        view_menu_reportes() {
            return (
              
                    this.valida_permiso("EmanifiestoAA.reportes.directos.ws") ||
                    this.valida_permiso("EmanifiestoAA.reportes.directos.ds") ||
                    this.valida_permiso("EmanifiestoAA.predeterminados.ds") ||
                    this.valida_permiso("EmanifiestoAA.predeterminados.ws") ||
                    this.valida_permiso("EmanifiestoAA.rectificaciones") ||
                    this.valida_permiso("EmanifiestoAA.operaciones") ||
                    this.valida_permiso("EmanifiestoAA.permisosprevios") ||
                    this.valida_permiso("EmanifiestoAA.cuentasaduaneras") ||
                    this.valida_permiso("EmanifiestoAA.analiticos")
            );
        },

      
        menu_vucem() {
            return (
               
                (
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.soia") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.linea.captura") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.pedimento") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.cove") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.edocument") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.acusese") ||
                    this.valida_permiso("EmanifiestoAA.Pedimento.consulta.estado") 
                ) 
            );
        },
        menu_edrive() {
            return (
               
                    this.valida_permiso("EmanifiestoAA.edrive.consultar") ||
                    this.valida_permiso("EmanifiestoAA.edrive.descargar") 
                
            );
        },
      
        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },
    
        menu_emanifest() {
            return (
              
                    this.valida_permiso("EmanifiestoAA.manifestacion") ||
                    this.valida_permiso("EmanifiestoAA.carta.porte.consultar") ||
                    this.valida_permiso("EmanifiestoAA.cfdi.consultar") 
                
            );
        },
       
        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },

      
        esGrupo() {
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
        linkConsultaRapida: function () {

            window.open("https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarap_cep.aspx", "_blank");

        },
        linkConsultaA24: function () {
            let email = this.$local_storage.get("email");
            let link = "https://integra24.mx/A24/ReportesA24U?USU=" + email;
            window.open(link, "_blank");
        },

        openNew: function (h) {
            window.open(h, "_blank");
        },

        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        hideMenuReportes: function () {

            var menu = document.getElementById("menuPermisosPrevios");
            var menu2 = document.getElementById("menuCuentasAduaneras");
            var menu3 = document.getElementById("menuIndicadoresEEA");
            var menu5 = document.getElementById("menuSoia");

            if (menu) {
                menu.click();
            }

            if (menu2) {
                menu2.click();
            }

            if (menu3) {
                menu3.click();
            }
            if (menu5) {
                menu5.click();
            }
        },
    },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
